import * as CryptoJS from 'crypto-js';

export class VoniSigner {
  /**
   * Generate an HMAC-SHA256 signature for a request.
   */
  static signRequest(
    apiKey: string,
    method: string,
    path: string,
    body: string = '',
    timestamp?: number
  ): string {
    const ts = timestamp ?? Math.floor(Date.now() / 1000);
    const message = `${ts}${method.toUpperCase()}${path}${body}`;

    return CryptoJS.HmacSHA256(message, apiKey).toString(CryptoJS.enc.Hex);
  }

  /**
   * Verify an incoming request signature.
   * Throws an error if invalid.
   */
  static verifySignature(
    signature: string,
    apiKey: string,
    method: string,
    path: string,
    body: string = '',
    timestamp: number,
    toleranceInSeconds: number = 300
  ): boolean {
    const now = Math.floor(Date.now() / 1000);

    // 1. Check timestamp freshness (Replay Attack Protection)
    if (Math.abs(now - timestamp) > toleranceInSeconds) {
      throw new Error('Request timestamp is too old (possible replay attack).');
    }

    // 2. Re-compute signature
    const expectedSignature = this.signRequest(
      apiKey,
      method,
      path,
      body,
      timestamp
    );

    // 3. Constant-time comparison to prevent timing attacks
    // This works in both Node.js and Browser environments
    if (signature.length !== expectedSignature.length) {
      return false;
    }

    let result = 0;
    for (let i = 0; i < signature.length; i++) {
      result |= signature.charCodeAt(i) ^ expectedSignature.charCodeAt(i);
    }
    return result === 0;
  }
}

